import React, { useEffect, useRef } from 'react';
import './InfoGraphic.scss';
import house from '../../assets/house.svg';
import houseDk from '../../assets/house-dk.svg';
import houseH from '../../assets/house-half.svg';
import money from '../../assets/money.svg';
import moneyDk from '../../assets/money-dk.svg';
import moneyH from '../../assets/money-half.svg';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function InfoGraphic() {
  const house1 = useRef();
  const house2 = useRef();
  const house3 = useRef();
  const house4 = useRef();
  const money1 = useRef();
  const money2 = useRef();

  const infoGraphicRef = useRef();

  useEffect(() => {
    const icon1 = gsap.utils.selector(house1);
    const icon2 = gsap.utils.selector(house2);
    const icon3 = gsap.utils.selector(house3);
    const icon4 = gsap.utils.selector(house4);
    const iconM1 = gsap.utils.selector(money1);
    const iconM2 = gsap.utils.selector(money2);
    ScrollTrigger.matchMedia({
      '(min-width: 768px)': function () {
        const icons1 = [icon1, icon3, iconM1];
        const icons2 = [icon2, icon4, iconM2];
        icons1.forEach((icon) => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: infoGraphicRef.current,
              start: 'top 75%',
              once: true,
              end: 'top 75%'
            }
          });
          tl.to(icon('.house, .money'), {
            opacity: 1,
            scale: 1,
            duration: 1,
            stagger: 0.1
          });
        });
        icons2.forEach((icon) => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: infoGraphicRef.current,
              start: 'top 75%',
              once: true,
              end: 'top 75%'
            }
          });
          tl.to(icon('.house, .money'), {
            opacity: 1,
            scale: 1,
            duration: 1,
            stagger: 0.1,
            delay: 0.5
          });
        });
      },
      '(max-width: 767px)': function () {
        const moneyIcons = [iconM1, iconM2];
        moneyIcons.forEach((icon) => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: money1.current,
              start: 'top 85%',
              once: true,
              end: 'top 85%'
            }
          });
          tl.to(icon('.money'), {
            opacity: 1,
            scale: 1,
            duration: 1,
            stagger: 0.1
          });
        });

        const allIcons = [icon1, icon2];
        allIcons.forEach((icon) => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: infoGraphicRef.current,
              start: 'top 75%',
              once: true,
              end: 'top 75%'
            }
          });
          tl.to(icon('.house'), {
            opacity: 1,
            scale: 1,
            duration: 1,
            stagger: 0.1
          });
        });
        const allIcons2 = [icon3, icon4];
        allIcons2.forEach((icon) => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: infoGraphicRef.current,
              start: 'top 75%',
              once: true,
              end: 'top 75%'
            }
          });
          tl.to(icon('.house'), {
            opacity: 1,
            scale: 1,
            duration: 1,
            stagger: 0.1,
            delay: 0.5
          });
        });
      }
    });
  }, []);

  return (
    <figure className="infoGraphic" ref={infoGraphicRef}>
      <div className="infoGraphic__graphic">
        <div className="infoGraphic__graphic-category infoGraphic__graphic-category-house">
          <div className="infoGraphic__graphic-category__icons">
            <div className="icons-sections">
              <div className="icons-sections-inner" ref={house1}>
                <img src={house} alt="house icon" className="house" />
                <img src={house} alt="house icon" className="house" />
                <img src={house} alt="house icon" className="house" />
              </div>
              <div className="icons-sections-inner" ref={house2}>
                <img src={house} alt="house icon" className="house" />
                <img src={house} alt="house icon" className="house" />
                <img src={house} alt="house icon" className="house" />
              </div>
            </div>
            <div className="icons-sections">
              <div className="icons-sections-inner" ref={house3}>
                <img src={house} alt="house icon" className="house" />
                <img src={house} alt="house icon" className="house" />
                <img src={house} alt="house icon" className="house" />
              </div>
              <div className="icons-sections-inner" ref={house4}>
                <img src={house} alt="house icon" className="house" />
                <img src={houseH} alt="house icon" className="house" />
                <img src={houseDk} alt="house icon" className="house" />
              </div>
            </div>
          </div>
          <div className="infoGraphic__contents-row__copy">
            <p className="infoGraphic__contents-row__copy-text">
              <span className="infoGraphic__contents-row__copy-number">88%</span>
              <br />
              of all home buyers feel that their home is a good financial investment
            </p>
          </div>
        </div>
        <div className="infoGraphic__graphic-category infoGraphic__graphic-category-money">
          <div className="infoGraphic__graphic-category__icons">
            <div className="icons-sections">
              <div className="icons-sections-inner" ref={money1}>
                <img src={money} alt="money icon" className="money" />
                <img src={money} alt="money icon" className="money" />
                <img src={moneyH} alt="money icon" className="money" />
              </div>
              <div className="icons-sections-inner" ref={money2}>
                <img src={moneyDk} alt="money icon" className="money" />
                <img src={moneyDk} alt="money icon" className="money" />
              </div>
            </div>
          </div>
          <div className="infoGraphic__contents-row__copy">
            <p className="infoGraphic__contents-row__copy-text">
              <span className="infoGraphic__contents-row__copy-number">50%</span>
              <br />
              say it’s better than stocks
            </p>
          </div>
        </div>
      </div>
      <figcaption className="infoGraphic__caption">
        Source: NAR, Profile of Home Buyers and Sellers, 2022
      </figcaption>
    </figure>
  );
}

export default InfoGraphic;
